var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362 305",
    style: {
      enableBackground: "new 0 0 362 305"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#43C9C9;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FF1515;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "calliope",
    className: "st0",
    d: "M91.8,4.7L91.8,4.7c7.1-5.3,16.9-5.5,24.2-0.6c14.5,9.8,40.2,24.3,64.9,24.3 c26.9,0,52.9-15.6,65.3-24.3c5-3.5,11.3-4.4,17.1-2.3l0.7,0.2c8.4,3,13.7,11.3,12.7,20.2c-1.9,17.8-3.5,48.5,15.1,72.8 c19.5,25.4,36.7,36.2,49,40.3c6.8,2.3,11.5,8.5,12,15.7v0c0.6,9.2-5.9,15.7-14.2,19.7c-13.9,6.6-35.6,18.1-49.5,41.9 c-16.8,28.8-15.2,59.4-13.4,72.5c0.8,5.9-1.8,11.7-6.8,14.9c-5.5,3.5-13.8,5.4-24.7-1.8c-6.3-4.1-13.8-9.9-24.1-13.8 c-12.5-4.8-19.5-6.3-23.5-6.7c-2.7-0.2-5.1-2.1-6-4.7c-1.3-3.4-4-7.2-9.5-7.2c-5.7,0-8.3,4.1-9.5,7.6c-1,2.9-3.8,4-6.9,4.2 c-5.6,0.5-14.5,2.8-23.7,7c-8.2,3.8-16.2,9.1-23.6,14.7c-6.4,4.8-17.3,6.3-23.6,1.5l0,0c-6.6-5.1-8.5-13.5-7.5-21.8 c2.2-17.7,1.3-50.1-19.3-74.4c-20.4-24.1-32.7-30.4-43-33.8c-4.5-1.5-13.2-6.3-14.3-16.3s3.5-16.8,12.6-21.3 c14.3-7,35.3-19.9,48.8-39.5c17.5-25.5,17.4-55.6,15.2-71.4C85.1,16,86.4,8.6,91.8,4.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.7,
    y: 67.8,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.7,
    y: 95.3,
    className: "st2",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.7,
    y: 122.8,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.7,
    y: 150.3,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.7,
    y: 177.8,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 67.8,
    className: "st2",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 95.3,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 122.8,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 150.3,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 177.8,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 67.8,
    className: "st2",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 95.3,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 122.8,
    className: "st2",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 150.3,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 177.8,
    className: "st2",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.5,
    y: 67.8,
    className: "st2",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.5,
    y: 95.3,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.5,
    y: 122.8,
    className: "st2",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.5,
    y: 150.3,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.5,
    y: 177.8,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.4,
    y: 67.8,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.4,
    y: 95.3,
    className: "st2",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.4,
    y: 122.8,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.4,
    y: 150.3,
    className: "st1",
    width: 14.9,
    height: 20.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.4,
    y: 177.8,
    className: "st1",
    width: 14.9,
    height: 20.9
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.ea109f17561cfa06d6eec90ce7253d7c.svg";
export { ForwardRef as ReactComponent };